import React, { TouchEvent, useCallback, useEffect, useState } from "react";
import { useWindowSize } from "../hooks/useWindowSize";
import { MDBBadge, MDBIcon, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from "mdb-react-ui-kit";

export interface TabsViewerTabProps {
    name: string;
    title: string;
    component: React.ReactNode;
    count?: number;
    icon?: string;
    disableSwipe?: boolean;
}

export interface TabsViewerProps {
    id: string;
    tabs: TabsViewerTabProps[];
    defaultTab: string;
    fullSize?: boolean;
    noFullHeight?: boolean;
}
export const TabsViewer = ({id, tabs, fullSize, defaultTab, noFullHeight}: TabsViewerProps) => {
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const [selected, setSelected] = useState(defaultTab || (tabs.length > 0 ? tabs[0].name : null));
    const { innerWidth, innerHeight } = useWindowSize();

    const handleTouchStart = useCallback((e: TouchEvent<HTMLElement>) => {
        if (fullSize || innerHeight >= 1000) return;
        setTouchStart(e.targetTouches[0].clientX);
        setTouchEnd(e.targetTouches[0].clientX);
    }, [fullSize, innerHeight]);
    
    const handleTouchMove = useCallback((e: TouchEvent<HTMLElement>) => {
        if (fullSize || innerHeight >= 1000) return;
        setTouchEnd(e.targetTouches[0].clientX);
    }, [fullSize, innerHeight]);
    
    const handleTouchEnd = useCallback(() => {
        if (fullSize || innerHeight >= 1000) return;
        const links = tabs.map(tab => Array.from(document.querySelectorAll<HTMLElement>(`#${tab.name}-link.nav-link`))[0]);
        const selectedIndex = links.findIndex(l => l.classList.contains('active'));
        let nextTabIndex = selectedIndex;

        if (touchStart - touchEnd > 100 && selectedIndex + 1 < links.length && !tabs[selectedIndex].disableSwipe) nextTabIndex = selectedIndex+1;
        if (touchStart - touchEnd < -100 && selectedIndex > 0 && !tabs[selectedIndex].disableSwipe) nextTabIndex = selectedIndex-1;

        if (nextTabIndex !== selectedIndex){
            links[nextTabIndex].click();
        }

        setTouchStart(0);
        setTouchEnd(0);
    }, [fullSize, innerHeight, tabs, touchStart, touchEnd]);


    return (
        <>
            <MDBTabs className="mb-3" id={id}>
                {tabs.map(tab => (
                    <MDBTabsItem key={"tabitem-"+tab.name} role="presentation">
                        {(innerWidth >= 1000 || fullSize) &&
                            <MDBTabsLink
                                className="p-2"
                                //active={tab.default || (autoDefault && index == 0)}
                                active={selected == tab.name}
                                onClick={() => setSelected(tab.name)}
                                id={tab.name + '-link'}
                                role="tab"
                            >
                                {tab.icon &&<i className={`${tab.icon} fa-fw ${tab.title ? ' me-2' : ''}`}/> }
                                {tab.title}
                                {typeof tab.count == 'number' && <MDBBadge className='ms-2' color='danger'>
                                    {tab.count}
                                </MDBBadge> }
                            </MDBTabsLink>
                        }
                        {(innerWidth < 1000 && !fullSize) &&
                            <MDBTabsLink
                                className="border-0"
                                style={{opacity: 0.5, padding: '2px', backgroundColor: 'transparent'}}
                                //active={tab.default || (autoDefault && index == 0)}
                                id={tab.name + '-link'}
                                active={selected == tab.name}
                                role="tab"
                                onClick={() => setSelected(tab.name)}
                            >
                                <MDBIcon icon="fas fa-circle" size="xs" style={{fontSize: '0.5em'}}/>
                            </MDBTabsLink>
                        }
                    </MDBTabsItem>
                ))}
            </MDBTabs>
            <MDBTabsContent
                id="grouptabs-content"
                className={`d-flex overflow-auto w-100${noFullHeight?'':' h-100 flex-fill'} `+(innerWidth >= 1000 ? ' mt-1':'')}
                onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}
            >
                {tabs.map((tab, index) => (
                    <MDBTabsPane
                        key={"tabpane-"+tab.name}
                        open={selected == tab.name}
                        className="w-100 h-100"
                        id={tab.name}
                    >
                        { tab.component }
                    </MDBTabsPane>
                ))}
            </MDBTabsContent>
        </>
    )
}